import React, { Component } from 'react';
import DomainList from './domain-list';
import AddDomainModal from './add-domain-modal';
import SuggestedDomainsModal from "./suggested-domains-modal"
import {
  Button,
  Container,
  Row,
  Col,
  Alert,
  Glyphicon,
  FormCheck,
  Tooltip,
} from 'react-bootstrap';

//libs
import {
  PeripheralLicenseDomain,
  PeripheralLicenseDomains,
} from '../lib/domain';
import StatusMessage from '../lib/statusmessage';

//api
import {
  addDomain,
  GetPeripheralLicensesOfLicenseID,
  generateDistributionKey,
} from '../api/peripheral-license';
import {AddToCart} from '../api/cart'

class CreateDistributionKeyApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      LicenseID: this.props.LicenseID || null,
      UserID: this.props.UserID || null,
      DistributionLicenseInfo: undefined,
      DistributionKey: undefined,
      SelectedDomains: [],
      showAddDomainModal: false,
      addDomainAlert: null,
      AddDomainModalLoading: false,
      showSuggestedDomainsModal: false,
      addDomainAlert: null,
      SuggestedDomainsModalLoading: false,
      generateDistributionKeyAlert: null,
      btnCopyDistributionKey: 'Copy to Clipboard',
      chkHideDomains: false,
      CustomLicenseName: undefined,

    };
    this.domainRegistrationLimit = this.domainRegistrationLimit.bind(this);
    this.getPeripheralLicensesOfLicenseID = this.getPeripheralLicensesOfLicenseID.bind(
      this
    );
    this.generateDistributionLicense = this.generateDistributionLicense.bind(
      this
    );
    this.selectedDomainsUpdated = this.selectedDomainsUpdated.bind(this);
    this.toggleAddDomainModal = this.toggleAddDomainModal.bind(this);
    this.toggleSuggestedDomainsModal = this.toggleSuggestedDomainsModal.bind(this);
    this.handleAddDomain = this.handleAddDomain.bind(this);
    this.checkPeripheralLicenseDomainValidity = this.checkPeripheralLicenseDomainValidity.bind(
      this
    );
    this.copyKeyToClipboard = this.copyKeyToClipboard.bind(this);
    this.toggleHideDomains = this.toggleHideDomains.bind(this);
    this.CustomLicenseNameChange = this.CustomLicenseNameChange.bind(this);
    this.AddToCart = this.AddToCart.bind(this);
  }
  async componentDidMount() {
    await this.getPeripheralLicensesOfLicenseID();
  }

  async getPeripheralLicensesOfLicenseID() {
    //Get the info from S1 for the distribution key given by the route

    let _dist = await GetPeripheralLicensesOfLicenseID(
      this.state.LicenseID
    ).catch(ex => {
      return null;
    });
    this.setState({
      DistributionLicenseInfo: _dist,
    });
  }

  //Client has clicked Generate Distribution License button.  Handle click event.
  async generateDistributionLicense() {
    this.setState({
      generateDistributionKeyAlert: null,
      DistributionKey: 'loading',
      btnCopyDistributionKey: 'Copy to Clipboard',
    });
    if (this.state.SelectedDomains.length <= 0) {
      this.setState({
        generateDistributionKeyAlert: new StatusMessage({
          Status: 'danger',
          Message: 'Please select at least one domain to generate a key for.',
        }),
        DistributionKey: null,
      });
    } else {
      let _distributionkey = await generateDistributionKey({
        LicenseID: this.state.LicenseID,
        IsProductKey: this.state.DistributionLicenseInfo.IsProductKey,
        CustomerID: this.state.UserID,
        Domains: this.state.SelectedDomains,
        NameInLicense: this.state.CustomLicenseName,
        HideDomainBeforeLicense: this.state.chkHideDomains,
      });
      this.setState({ DistributionKey: _distributionkey });
    }
  }

  //DomainList child.  Client has selected values within checkboxes.
  selectedDomainsUpdated(domains: Array) {
    this.setState({ SelectedDomains: domains });
  }

  //Client has toggled visibility of the child AddDomain modal.
  toggleAddDomainModal() {
    this.setState({
      showAddDomainModal: !this.state.showAddDomainModal,
      addDomainAlert: null,
    });
  }

  toggleSuggestedDomainsModal() {
    this.setState({
      showSuggestedDomainsModal: !this.state.showSuggestedDomainsModal,
      addDomainAlert: null,
    });
  }

  toggleHideDomains({ target }) {
    this.setState({ chkHideDomains: target.checked, CustomLicenseName: '' });
  }
  CustomLicenseNameChange({ target }) {
    this.setState({ CustomLicenseName: target.value });
  }

  domainRegistrationLimit() {
    if (this.state.DistributionLicenseInfo.DomainsAllowed > -1) {
      return this.state.DistributionLicenseInfo.DomainsAllowed - this.state.DistributionLicenseInfo.DomainsRegistered
    } else {
      return -1;
    }
  }

  async AddToCart(e, data){

    try{
        e.preventDefault();
        let added = await AddToCart(data);
        window.location.replace(added.url);

    }catch(ex){
        console.log(ex);
    }
}

  //Child AddDomain modal popup.  Client has clicked AddDomain.  Handle click event.
  async handleAddDomain(args) {

    return new Promise(async (resolve, reject) => {
      this.setState({ AddDomainModalLoading: true });

      //Status msg
      let _adddomainalert = new StatusMessage();

      let domains = [];

      //Create Array of PeripheralLicenseDomains
      if (typeof args === "string") {
        domains.push(new PeripheralLicenseDomain({ Name: args }))
      } else if (typeof args === "object") {
        for (let d of args) {
          if (d instanceof PeripheralLicenseDomain) {
            domains.push(d);
          } else {
            domains.push(new PeripheralLicenseDomain({ Name: d.Name }))
          }

        }
      }

      try {
        if (this.state.DistributionLicenseInfo.DomainsAllowed !== -1 && this.state.DistributionLicenseInfo.DomainsRegistered >= this.state.DistributionLicenseInfo.DomainsAllowed) throw new StatusMessage({ Status: "danger", Message: "You have reached the hostname registration limit.  Please generate a key with hostnames already registered." });
        if (domains.length <= 0) throw new StatusMessage({ Status: "danger", Message: "Please select a domain" });
        //Check validity of all PeripheralLicenseDomain items, and throw error if needed

        await Promise.all(domains.map(async d => {
          await this.checkPeripheralLicenseDomainValidity(d);
        }));

        //Client input valid domain.  Preprend wildcard if necessary
        if (this.state.DistributionLicenseInfo.IsWildcardSupported == true) {
          domains.forEach((domain) => {
            if (!domain.Name.startsWith("*."))
              domain.Name = `*.${domain.Name}`;
          })
        }

        //AddDomain API call to S1
        await addDomain(domains, this.state.LicenseID, this.state.UserID)
          .then(async (resp) => {
            _adddomainalert =
              resp.Code === 0
                ? new StatusMessage({
                  Status: 'success',
                  Message: 'The hostname has been added successfully!',
                })
                : new StatusMessage({
                  Status: 'danger',
                  Message: 'The hostname was not able to be added.',
                });
            //After the domain was added, refresh the license in the state to grab new list of domains
            await this.getPeripheralLicensesOfLicenseID();
          })
          .catch(ex => {
            _adddomainalert = new StatusMessage({
              Status: 'danger',
              Message: ex.message,
            });
          });
      }
      catch (ex) {
        //throw error message of validity check fails on any items
        _adddomainalert = ex;

      } finally {
        //Promise rejection from status !=200 or error in api function
        this.setState({
          addDomainAlert: _adddomainalert,
          AddDomainModalLoading: false,
        });
        if (_adddomainalert.Status == 'danger') {
          reject(_adddomainalert);
        } else { resolve(_adddomainalert) };
      }

    });
  }

  //Error checking for Name value of PerpetualLicenseDomain client input.  Return message to display for error/success.
  async checkPeripheralLicenseDomainValidity(domain: PeripheralLicenseDomain) {
    return new Promise((resolve, reject) => {

      if (domain.Name === null || domain.Name === '') {
        reject(new StatusMessage({
          Status: 'danger',
          Message: 'Please enter a hostname.',
        }));
      } else if (
        this.state.DistributionLicenseInfo.Domains.find(x => {
          if (x.Name === domain.Name) return true;
        })
      ) {
        reject(new StatusMessage({
          Status: 'danger',
          Message: 'The hostname you have entered has already been added!',
        }));
      } else if (!domain.IsValid(this.state.DistributionLicenseInfo.IsWildcardSupported)) {
        reject(new StatusMessage({
          Status: 'danger',
          Message: `The hostname "${domain.Name}" is not in a valid format.`,
        }));
      } else {
        resolve(new StatusMessage({
          Status: 'success',
          Message: 'The hostname has been added!',
        }));
      }

    });
  }

  copyKeyToClipboard(e) {
    this.keyTextArea.select();
    document.execCommand('copy');
    e.target.focus();
    this.setState({ btnCopyDistributionKey: 'Copied!' });
  }

  render() {
    return (
      <div className="react-distkey-wrap gc-form">
        <Container>
          {this.state.DistributionLicenseInfo && (
            <div>
              <Row>
                <Col md={12}>
                  <Row>
                    <Col md={12}>
                      <h2>{this.state.DistributionLicenseInfo.ProductName}</h2>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12} className="distkey-notes">
                      <p><strong>IMPORTANT:</strong></p>
                      <ul>
                        <li>When registering multiple hostnames, click ADD A HOSTNAME after each.</li>
                        <li>When you click GENERATE DISTRIBUTION KEY, you'll get a single key to be added to the apps in the hostname(s) you register during this generation session.</li>
                        <li>Your distribution key is only available during this generation session, so be sure to copy it for your records.​</li>
                        <li>If you need to add more hostnames in the future, those hostnames will have different distribution keys.</li>
                        <li>Subdomains must be registered separately. For instance, www.domain.com is not the same hostname as domain.com, and should be added additionally.​</li>
                        {!this.state.DistributionLicenseInfo.IsWildcardSupported && <li>Wildcards will not be accepted. Please contact <a href="mailto:us.sales@mescius.com">us.sales@mescius.com</a> for wildcards.​</li>}
                        {this.state.DistributionLicenseInfo.IsWildcardSupported && <li><b>For this license, please register domain names (ex. mescius.com).  The license key, when generated, will cover all subdomains in the domain (ex. www.mescius.com, developer.mescius.com, etc.) </b></li>}
                      </ul>
                      <p><a href="/licensing/generate-distribution-key">Read more about distribution keys.</a></p>
                    </Col>
                  </Row>
                  <Row className="distkey-header">
                    <Col md={4} className="distkey-header-reg">
                      <p>
                        <strong>Hostnames Registered:&nbsp;&nbsp;</strong>
                        {this.state.DistributionLicenseInfo.DomainsRegistered} / {
                          this.state.DistributionLicenseInfo.DomainsAllowed == -1 ? "Unlimited" : this.state.DistributionLicenseInfo.DomainsAllowed
                        }
                      </p>
                      {this.state.DistributionLicenseInfo.AddonDomains !=0 && <p style={{"fontSize":"13px"}}>Includes <b>{this.state.DistributionLicenseInfo.AddonDomains}</b> Extra/Commercial Hostnames</p>}
                    </Col>
                    <Col md={8}>
                      <Row>
                        <Col className="distkey-header-add">
                          {((this.state.DistributionLicenseInfo.DomainsRegistered < this.state.DistributionLicenseInfo.DomainsAllowed) || this.state.DistributionLicenseInfo.DomainsAllowed == -1) &&
                            <Button
                              className="gc-btn primary-action distkey-prd-btn"
                              onClick={this.toggleAddDomainModal}
                            >
                              <i className="fa fa-plus" /> Add a Hostname
                            </Button>
                          }
                        </Col>
                        {((this.state.DistributionLicenseInfo.DomainsRegistered < this.state.DistributionLicenseInfo.DomainsAllowed) || this.state.DistributionLicenseInfo.DomainsAllowed == -1) && this.state.DistributionLicenseInfo.SuggestedDomains.length > 0 &&
                          <Col className="distkey-header-add">
                            <Button
                              className="gc-btn primary-action distkey-prd-btn"
                              onClick={this.toggleSuggestedDomainsModal}
                            >
                              <i className="fa fa-plus" /> Add Previously Registered Domains
                            </Button>
                          </Col>

                        }
                        {this.state.DistributionLicenseInfo.SAASProductCode==`W21B` &&
                        <Col className="distkey-header-add">
                            <Button
                              className="gc-btn primary-action distkey-prd-btn"
                              onClick={e=>this.AddToCart(e, {"sku":62767, "forSubscription":this.state.DistributionLicenseInfo.LicenseID})}
                            >
                              <i className="fa fa-plus" /> Purchase Additional Hostnames
                            </Button>
                          </Col>
                        }
                      </Row>
                    </Col>
                  </Row>
                  <Row className="distkey-alerts">
                    <Col md={12}>
                      {this.state.generateDistributionKeyAlert && (
                        <div>
                          <Alert
                            variant={
                              this.state.generateDistributionKeyAlert.Status
                            }
                          >
                            {this.state.generateDistributionKeyAlert.Message}
                          </Alert>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="distkey-domains">
                    <Col md={12}>
                      {this.state.DistributionLicenseInfo.Domains.length > 0 ? (
                        <DomainList
                          domains={this.state.DistributionLicenseInfo.Domains}
                          onSelectedDomainsChanged={this.selectedDomainsUpdated}
                        />
                      ) : (
                        <Alert variant="warning">
                          You do not have any hostnames registered. Click Add
                          Hostname to get started!
                        </Alert>
                      )}
                    </Col>
                  </Row>
                  <Row className="distkey-actions">
                    <Col md={6} className="distkey-actions-btn">
                      <Button
                        className="gc-btn primary-action"
                        onClick={this.generateDistributionLicense}
                      >
                        Generate Distribution Key
                      </Button>
                    </Col>
                    <Col md={6} className="distkey-actions-options">
                      {this.state.chkHideDomains && (
                        <input
                          value={this.state.CustomLicenseName}
                          type="input"
                          placeholder="Insert license name"
                          onChange={this.CustomLicenseNameChange}
                          maxLength="50"
                          minLength="1"
                        />
                      )}
                      <FormCheck
                        type="checkbox"
                        value={this.state.chkHideDomains}
                        name={`chkHideDomains`}
                        id={`chkHideDomains`}
                        onClick={this.toggleHideDomains}
                        label={`Hide hostnames within generated key?`}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>


              <Row>
                {this.state.DistributionKey &&
                  this.state.DistributionKey.key && (
                    <Col md={12} className="distkey-key">

                      <Row>
                        <Col md={12}>
                          <h4>
                            Copy this key and use it in your apps immediately.
                            An email has been sent to you containing a copy of
                            this key.
                          </h4>
                          <p>
                            <a
                              href="/licensing/generate-distribution-key"
                              target="_blank"
                            >
                              Learn how to add this distribution key to your
                              apps.
                            </a>
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <textarea
                            ref={keyTextArea =>
                              (this.keyTextArea = keyTextArea)
                            }
                            rows="15"
                            className="distkey-display"
                            readOnly
                            value={this.state.DistributionKey.key}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="distkey-clipbtn">
                          <Button onClick={this.copyKeyToClipboard} className="gc-btn primary-action">
                            {this.state.btnCopyDistributionKey}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  )}
              </Row>
              <Row>
                <Col md={12} className="distkey-gen-info">
                  {this.state.DistributionKey &&
                    this.state.DistributionKey.Message && (
                      <Alert variant={'danger'}>
                        {this.state.DistributionKey.Message.msg}
                      </Alert>
                    )}
                  {this.state.DistributionKey === 'loading' && (
                    <p>
                      <i className="fa-spinner fa fa-spin" />
                    </p>
                  )}
                </Col>
              </Row>
            </div>
          )}
          {this.state.DistributionLicenseInfo === null && (
            <Row>
              <Col md={12} className="distkey-init-alert">
                <Alert variant={'danger'}>
                  Unable to fetch license information from server.
                </Alert>
              </Col>
            </Row>
          )}
          {this.state.DistributionLicenseInfo === undefined && (
            <Row>
              <Col md={12} className="distkey-init-spinner">
                <p>
                  <i className="fa-spinner fa fa-spin" />
                </p>
              </Col>
            </Row>
          )}
        </Container>
        {
          this.state.DistributionLicenseInfo &&
          <AddDomainModal
            showAddDomainModal={this.state.showAddDomainModal}
            handleCloseAddDomainModal={this.toggleAddDomainModal}
            supportWildcard={this.state.DistributionLicenseInfo.IsWildcardSupported}
            handleAddDomain={this.handleAddDomain}
            loading={this.state.AddDomainModalLoading}
            alert={this.state.addDomainAlert}
          />

        }
        {
          this.state.DistributionLicenseInfo &&
          <SuggestedDomainsModal
            showSuggestedDomainsModal={this.state.showSuggestedDomainsModal}
            handleCloseAddDomainModal={this.toggleSuggestedDomainsModal}
            handleAddDomain={this.handleAddDomain}
            SuggestedDomains={this.state.DistributionLicenseInfo.SuggestedDomains.map((x) => new PeripheralLicenseDomain(x))}
            loading={this.state.AddDomainModalLoading}
            alert={this.state.addDomainAlert}
            domainsAddedLimit={this.domainRegistrationLimit()}
          />
        }

      </div>
    );
  }
}

export default CreateDistributionKeyApp;
